import { DateRange } from './../../../user/survey-list/date.range.model';
import {
  Component,
  OnInit,
  TemplateRef,
  ChangeDetectionStrategy,
} from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { ModalBase } from '../modal-base';
import { CategoriesService } from '../../../services/categories.service';
import { ConfigService } from '../../../services/config.service';
import { Category } from '../../../models/questions';
import { SaveFormService } from '../../../services/save-form.service';
import { EnumDescription } from '../../../helpers/enum-description.helper';
import { QuestionCategoryType } from '../../../models/questions/question-category-type.enum';
import { TimerHelper } from '../../../helpers';
import { ProcessTypeFeatureFlags } from '../../../models/process-type-feature-flags.enum';

@Component({
  selector: 'app-modal-create',
  templateUrl: './modal-create.component.html',
  styleUrls: ['./modal-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCreateComponent implements OnInit {
  modalData: Category = { localizedNames: [], questionCategoryTypes: [] };
  modalForm: FormGroup;
  modalRef: BsModalRef;
  propName = 'name_';
  propertiesArray: Array<string> = [];
  placeholderArray: Array<string> = [];
  baseModal: ModalBase;
  checkBoxesControls: Array<FormControl>;
  isOnSaving: boolean = false;
  questionCategoryType = QuestionCategoryType;
  feature = ProcessTypeFeatureFlags;

  private saveClicked: boolean;
  constructor(
    private modalFormBuilder: FormBuilder,
    private modalService: BsModalService,
    private categoriesServices: CategoriesService,
    private appData: ConfigService,
    private saveFormService: SaveFormService
  ) {}

  openModal(template: TemplateRef<any>) {
    this.baseModal = new ModalBase(
      this.categoriesServices,
      this.modalData,
      this.appData
    );
    this.modalForm = this.modalFormBuilder.group({
      checkboxes: this.baseModal.buildCheckboxControls(this.modalFormBuilder),
    });
    this.saveFormService.addAllLocalizedNameToFormGroup(
      this.modalForm,
      this.propName
    );
    this.propertiesArray = this.saveFormService.mapFormGroupControlToPropArray(
      this.modalForm,
      this.propName
    );
    this.saveFormService.addValidationToLocalizedControls(
      this.modalForm,
      this.propName
    );
    this.placeholderArray = this.saveFormService.setPlaceholderArrayByPropName(
      this.propertiesArray
    );
    this.modalRef = this.modalService.show(template);
    this.checkBoxesControls = this.baseModal.getCheckBoxes(this.modalForm);
  }

  ngOnInit() {
    this.modalService.onHide.subscribe(() => {
      this.isOnSaving = false;
    });
  }

  getCheckboxLabel(indexValue: number) {
    const enumValue = this.getQuestionCategoryTypeByIndex(indexValue);
    return EnumDescription.GetDescription(QuestionCategoryType, enumValue);
  }

  getQuestionCategoryTypeByIndex(indexValue: number) {
    return Math.pow(2, indexValue);
  }

  canShowFormControlError(formControlName: string): boolean {
    return (
      this.saveClicked &&
      this.saveFormService.canShowFormControlFieldError(
        this.modalForm,
        formControlName
      )
    );
  }

  onSave() {
    if (this.isOnSaving || this.modalForm.invalid) {
      this.showErrorTooltipTimer();
      return;
    }
    this.isOnSaving = true;
    this.modalData.localizedNames = this.baseModal.mapFormvalueToCategory(
      this.modalForm.value,
      this.propName
    );
    this.baseModal.mapCheckboxesValues(this.modalForm);
    this.baseModal.saveOnAdd(this.modalData, this.modalRef);
    this.modalData.questionCategoryTypes = [];
  }

  private showErrorTooltipTimer() {
    this.saveClicked = true;
    this.isOnSaving = false;
    TimerHelper.timer(
      this.appData.configData.displayTooltipTimeMilliseconds,
      () => (this.saveClicked = false)
    );
  }
}
